import React from "react";

import {
    FaChartLine,
    FaFileInvoiceDollar,
    FaMoneyBillWave,
    FaWallet,
    FaGlobe,
    FaStore,
} from "react-icons/fa";

import MetricCard from "./MetricCard";
import SectionCard from "./SectionCard";

import {
    formatCurrency,
    formatNumber,
} from "../utils/dashboardFormatters";


const SalesOverview = ({
    sales = {},
    filter = {},
}) => {

    return (

        <SectionCard
            title="Sales Performance"
            subtitle="Selected period sales performance and collection overview."
            className="dashboard-sales-section"
        >

            <div className="dashboard-sales-grid">

                <MetricCard
                    title="Total Sales"
                    value={
                        formatCurrency(
                            sales?.totalSales
                        )
                    }
                    icon={FaMoneyBillWave}
                    growth={
                        sales?.growthPercentage
                    }
                    emphasis
                />


                <MetricCard
                    title="Invoices"
                    value={
                        formatNumber(
                            sales?.totalInvoices
                        )
                    }
                    icon={FaFileInvoiceDollar}
                />


                <MetricCard
                    title="Average Invoice"
                    value={
                        formatCurrency(
                            sales?.averageInvoiceValue
                        )
                    }
                    icon={FaChartLine}
                />


                <MetricCard
                    title="Collected"
                    value={
                        formatCurrency(
                            sales?.paidAmount
                        )
                    }
                    icon={FaWallet}
                />


                <MetricCard
                    title="Outstanding"
                    value={
                        formatCurrency(
                            sales?.outstandingAmount
                        )
                    }
                    icon={FaWallet}
                />


                <MetricCard
                    title="Online Sales"
                    value={
                        formatCurrency(
                            sales?.onlineSales
                        )
                    }
                    icon={FaGlobe}
                />


                <MetricCard
                    title="Store Sales"
                    value={
                        formatCurrency(
                            sales?.storeSales
                        )
                    }
                    icon={FaStore}
                />

            </div>


            <div className="dashboard-sales-bottom">

                <div className="dashboard-sales-highlight">

                    <span>
                        Previous Period Sales
                    </span>

                    <strong>
                        {
                            formatCurrency(
                                sales?.previousSales
                            )
                        }
                    </strong>

                </div>


                <div className="dashboard-sales-highlight">

                    <span>
                        Current Filter
                    </span>

                    <strong>
                        {
                            filter?.period ||
                            "TODAY"
                        }
                    </strong>

                </div>

            </div>

        </SectionCard>

    );
};


export default SalesOverview;